import * as Stores from '../stores'

export function useBenefits() {
  const benefits = Stores.CardBenefitsApi.endpoints['GET /benefits'].useQuery(
    {},
    {
      selectFromResult({ data, isLoading, isUninitialized, isSuccess, error }) {
        return {
          isUninitialized,
          isLoading,
          isSuccess,
          error,
          data: data?.benefits ? data.benefits : undefined,
        }
      },
    },
  )

  return benefits
}
